import React, {useEffect, useState} from 'react';
import parseHtml from 'html-react-parser';

import {exportPrestamoDetalle, getClientes, getCompanias, getContrato, getCxC, getPrestamo} from '../../services';
import "./reportStyle.scss"
import {
    buildAmort,
    formatDate,
    formatPeso,
    geoString,
    htmltoText,
    setLSLang,
    translateText,
    urlPramsToObj
} from "../../helpers";
import {useLocation, useParams} from "react-router-dom";
import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogContent,
    FormControl,
    FormControlLabel,
    Grid,
    Input, InputAdornment,
    ListItemText,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Theme,
    Typography
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {ID_TOKEN_KEY} from "../../services/auth";
import {SelectEnum} from "../../components/selects";
import {filterCxCList} from "../../components/homeWidget/CxC";
import {HtmlTooltip, LoadingProgress, MostrarError} from "../../components";
import {isMobile} from "../../helpers/browser_detect";
import Strings from "../../assets/strings";
import {useCustomFormInput} from "../../hooks/useCustomFormInput";
import SelectPlantilla from "../../components/selects/SelectPlantilla";
import {IAmortizacion, ICuentasXCobrar, IPrestamoDetalle} from "../../redux/types/IPrestamo";
import {ConfCamposType, ICompania} from "../../redux/types/ICompania";
import {ICliente} from "../../redux/types/ICliente";
import {ESTADO_PRESTAMO, getValueString, SITUACION_PRESTAMO} from "../../helpers/CONSTANTES";

const useStyles = makeStyles((theme:Theme) => ({
    root:{
        background: "white !important",
        maxWidth: 980,
        border:"5px solid white",
        margin: "0 auto",
        '@media print': {
            minWidth: "10in !important",
            "& .MuiTableContainer-root":{
                overflow: "Hidden",
            }
        },
    },
    topBar:{
        position:"sticky",
        top:0,
        left:0,
        background:theme.palette.grey[800],
        height:40,
        width: "100%",
        color:theme.palette.common.white,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "& .controls":{
            "& select":{
                "marginRight": "8px",
                "padding": "5px",
                "border": "none !important",
                "background": "#545454",
                "paddingRight": "10px",
                "color": "inherit",
                "outline": "none",
                "textTransform": "uppercase",
                "& option":{
                    "background": "white",
                    color:"black",
                }
            }
        },
        '@media print': {
            display:"none",
        },
    },
    toShow:{
        marginRight: theme.spacing(1),
        "&>div":{
            background: "#545454",
            border: "none !important",
            paddingRight: 10,
            "&::before":{
                display:"none",
            },
            "& svg":{
                color:"white",
            },

            "&>div":{
                padding: "4px 15px !important",
                fontWeight: 500,
                fontSize: "0.875rem",
                textTransform: "uppercase",
                color: "white"
            }
        }
    },
    infoPrestamo:{
        margin: theme.spacing(1)+" 0px",
        background: "#f9f9f9",
        padding: 8,
        // [theme.breakpoints.down(undefined)]: {
        //     overflow: "auto",
        //     "&>div":{
        //         display: "block",
        //         columns: 2,
        //         width: 437,
        //         "&>div":{
        //             maxWidth: "100%",
        //         }
        //     },
        // },
        // [theme.breakpoints.down(400)]:{
        //     columns: 2,
        // },
        "&>div div":{
            marginBottom: 5,
            "&>span:first-child":{
                marginRight: 3,
                fontWeight: 500,
            }
        }
    },
    cliInfo:{
        padding: "8px 0",
        display:"flex",
        "&>div.avatar":{
            padding:0,
            margin:0,
        },
        "&>div.info":{
            margin:0,
        },
        // [theme.breakpoints.down(undefined)]: {
        //     flexDirection: "column",
        //     "&>div.avatar":{
        //         justifyContent: "center",
        //         marginBottom: 10,
        //     },
        // },
    },
    client:{
        margin: theme.spacing(1)+" 0px",
        padding: 8,
        display: "flex",
        alignItems: "center",
        "& img":{
            marginRight:theme.spacing(1),
            border: "1px solid #ccc",
        }
    },
    cliItems:{
        // [theme.breakpoints.down(undefined)]: {
        //     display: "block",
        //     // columns: 2,
        //     "&>div":{
        //         maxWidth: "100%",
        //         overflow: "hidden",
        //         whiteSpace: "nowrap",
        //         textOverflow: "ellipsis",
        //         padding: "8px 22px !important",
        //     }
        // }
    },
    cliImgCont:{
        // [theme.breakpoints.down(undefined)]: {
        //     flexDirection: "column",
        //     "&>div":{
        //         maxWidth: "100%",
        //         "& img":{
        //             margin: "0 auto",
        //             display: "block",
        //         }
        //     }
        // }
    },
    topHead: {
        display: "flex",
        justifyContent: "space-between",
        textAlign: "right",
        height: "67px",
        alignItems: "center",
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        borderBottom: "1px solid #ddd",
        "& .info":{
            display: 'flex',
            alignItems: "center",
        },
        "& h1":{
            color:theme.palette.primary.main,
            fontWeight: "normal",
            margin: "0",
            fontSize: "1.2rem",
            minWidth: 254,
            textAlign: "left",
            textTransform: "uppercase",

        },
        "& h2":{
            color:theme.palette.secondary.main,
            fontWeight: "normal",
            margin: "0",
            fontSize: "1.2rem",
        },
        "& .logo":{
            marginLeft: 10,
            maxWidth: 180,
            textAlign: "left",
            "& img":{
                maxWidth: 150,
                maxHeight: 64,
            },
        },
        "& span":{
            padding: 0,
            "&.tel":{
                fontSize:".7rem",
            },
            "&.dir":{
                fontSize:".7rem",
            }
        }
    },
    barTitle:{
        padding: "6px 12px",
        background: theme.palette.grey[100],
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        "& .total":{
            fontSize: 14,
            color: "rgba(0, 0, 0, 0.87)",
            display: "flex",
            alignItems: "center",
            "& div:first-child":{
                marginRight: 10
            },
            "& div:last-child":{
                textAlign: "right"
            },
            "& span":{
                color: theme.palette.secondary.main,
            },
        },
        // [theme.breakpoints.down(undefined)]: {
        //     flexDirection: "column",
        //     alignItems: "center",
        //     "& .total":{
        //         marginTop:5,
        //     }
        // }
    },
    campo:{
        "& span":{
            display: "block",
            height: 22,
            borderBottom: "1px solid #7b7b7b",
        },
        "& label":{
            fontSize: 13,
        }
    },
    tableCxc:{
        "& .head":{
            borderBottom: "1px solid "+theme.palette.primary.main,
            background: "#f6f6f6",
            marginBottom: 7,
            textTransform: "uppercase",
            padding: "0 8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        "&>div":{
            paddingBottom: 7,
            "& .detalles":{
                "&>div":{
                    background:"white"
                }
                // columns: 2,
                // "& p":{
                //     margin:0,
                //     "& span:first-child":{
                //         fontWeight: 500,
                //         marginRight: 10,
                //     }
                // }
            }

        }
    },
    contratoContent:{
        color:"#000",
        background:"white",
        fontSize: "18px !important",
        "& p":{
            textAlign: "justify",
            color: "black",
            fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
            lineHeight: "30px",
        },
        "& table": {
            tableLayout: "fixed",
            width:"100%",
            "& *":{
                color: "inherit",
                border: "none !important",
                textAlign: "center",
                "& p": {
                    margin: 0,
                    lineHeight: "21px",
                    "&:first-child":{
                        fontWeight: "bold",
                        fontSize: 16,
                        textTransform: "uppercase",
                    }
                }

            },
            "& tr": {
                background: "white !important",
            },
            "& td": {
                paddingBottom: 79,
            }
        },
    }
}));
export default function Reports() {
    const classes = useStyles();
    let location = useLocation()
    let {type,id} = useParams();
    let query:any = urlPramsToObj(location.search);

    //to show
    const [mostrarOpt, setMostrarOpt] = useState(["cabecera"]);
    const [aMostrar, setAMostrar] = useState(["cabecera"]);


    const [compania, setCompania] = useState<ICompania>({});
    const [content, setContent] = useState<any|null>(null);
    const [plantillaId, setPlantillaId] = useState<number>()
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState({content: false, compania:false})

    const [newUpdate, setNewUpdate] = useState(false);

    useEffect(() => {

        let query:any = urlPramsToObj(location.search);
        if(query.t && query.l){
            localStorage.setItem(ID_TOKEN_KEY, query.t);
            let lc = query["l"].split("-");
            setLSLang(lc[0]);
            Strings.setLanguage(lc[0]);

            delete query["t"];
            delete query["l"];
        }

        let req;
        switch (type){
            case "cxc":
                req = getCxC(query?.estado === "incluirCxcAldia");
                document.title = Strings.cuentasXcobrar+"_"+formatDate(new Date())
                break
            case "detallesPrestamo":
                req = getPrestamo(parseInt(id!));
                let ar = ["cabecera","total", "foto", "pagos", "amortizacion"];
                setMostrarOpt(ar);
                setAMostrar(ar);
                break
            case "contrato":
                // req = getPlantillaConverted(plantillaId, id);
                req = getContrato(parseInt(id!),plantillaId);
                document.title = Strings.contrato+"_"+formatDate(new Date());
                setAMostrar([]);
                break
            case "cliente":
                req = getClientes(parseInt(id!));
                break
            case "amortizacion":
                document.title = Strings.amortizacion+"_"+formatDate(new Date())
                const {capital,interes,cuotas,ciclosPago,tipoAmortizacian,fecha} = query;
                let amort:IAmortizacion[] = buildAmort(capital,interes,cuotas,ciclosPago,tipoAmortizacian,fecha);
                setContent(amort);

                setMostrarOpt(["cabecera","total"]);
                setAMostrar(["cabecera","total"]);
                break
            default:
                req = null
        }

        if(req) {
            setLoading(prev=>({...prev,content:true}));

            req.then(({data})=>{
                setContent(data);
            }).catch(error=>{
                setContent(null);
                setError(error?.response)
            }).finally(()=>setLoading(prev=>({...prev,content:false})));
        }
    }, [type,id,plantillaId,setContent,setError,location,setLoading,setMostrarOpt,setAMostrar]);

    useEffect(()=>{
        setLoading(prev=>({...prev,compania:true}));

        getCompanias().then(({data})=>{
            setCompania(data)
        }).finally(()=>setLoading(prev=>({...prev,compania:false})));

    },[])
    const imprimir = ()=>{
        if(isMobile.anyWebView() && type === "contrato"){
            if((window as any).ReactNativeWebView ){

                let ms = {
                    action: "imprimirTexto",
                    payload:  htmltoText(content)
                }

                return (window as any).ReactNativeWebView.postMessage(JSON.stringify(ms))

            }else if((window as any).webkit?.messageHandlers?.printTextAPP){
                return (window as any).webkit.messageHandlers.printTextAPP.postMessage(htmltoText(content));
            }else if((window as any).Android?.printTextAPP){
                return  (window as any).Android.printTextAPP(htmltoText(content));
            }
        }
        window?.print();
    }

    return (
        <>
            <Dialog
                open={newUpdate}
                onClose={()=>setNewUpdate(false)}
            >
                <DialogContent>
                    <Typography>¡Nueva actualización disponible!</Typography>
                    <br/>
                    <Button component={"a"} onClick={()=>setNewUpdate(false)}
                            color={"primary"}
                            href={isMobile.iOS()?"https://apps.apple.com/app/id6471681320":"https://play.google.com/store/apps/details?id=com.dsegura.prestamistapp3"}
                            rel="noopener noreferrer"
                            target={"_Blank"}
                            fullWidth
                    >
                        {Strings.actualizar}
                    </Button>
                    <Button size={"small"} fullWidth onClick={()=>setNewUpdate(false)}>Mas tarde</Button>

                </DialogContent>
            </Dialog>

            <div className={"reportPrint "+ classes.root}>
                {(loading.content || loading.compania) && <LoadingProgress vh/>}

                <div className={classes.topBar}>
                    <div>
                        <Button color={"inherit"} onClick={imprimir}>{Strings.imprimir}</Button>
                        {/*{type === "contrato" && !!content && <Hidden only={"xs"}>*/}
                        {/*    <Button color={"inherit"} onClick={()=>textToPDF(content,58)}>58mm</Button>*/}
                        {/*    <Button color={"inherit"} onClick={()=>textToPDF(content,80)}>80mm</Button>*/}
                        {/*</Hidden>}*/}
                    </div>
                    <div className={"controls"}>
                        {/*<FormControlLabel control={<Switch size="small" checked={showCabecera} onChange={(e)=>setShowCabecera(e.target.checked)}/>} label={Strings.cabecera} />*/}
                        {type === "contrato" &&
                            <SelectPlantilla
                                value={plantillaId}
                                onChange={({target}) => {
                                    setPlantillaId(target.value? parseInt(target.value):undefined);
                                    setError(null)
                                }}
                            />
                            // <select
                            //        value={plantillaId}
                            //         onChange={(e) => {
                            //             setPlantillaId(e.target.value);
                            //             setError(null)
                            //         }}
                            // >
                            //     <option value="1">{Strings.plantillaId} 1</option>
                            //     <option value="2">{Strings.plantillaId} 2</option>
                            //     <option value="3">{Strings.plantillaId} 3</option>
                            // </select>
                        }

                        <FormControl className={classes.toShow} size={"small"}>
                            <Select
                                multiple
                                value={aMostrar}
                                onChange={({target})=>setAMostrar(target.value as string[])}
                                input={<Input />}
                                displayEmpty={true}
                                renderValue={() => Strings.mostrar}
                            >
                                {mostrarOpt.map((name) => (
                                    <MenuItem key={name} value={name}>
                                        <Checkbox checked={aMostrar.indexOf(name) > -1} />
                                        <ListItemText primary={translateText(name)} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>



                {error && <MostrarError errors={error} />}

                {type === "cxc" && !!content &&
                    <CxC content={content} query={query} />
                }
                {type === "detallesPrestamo" && !!content &&
                    <DetallesPrestamo content={content} aMostrar={aMostrar}/>
                }
                {type === "contrato" && !!content &&
                    <Contrato content={content} />
                }
                {type === "cliente" && !!content &&
                    <Cliente content={content} />
                }
                {type === "amortizacion" && !!content &&
                    <Amortizacion {...{content, query, aMostrar}}/>
                }
            </div>
        </>
    );
}

function CxC({content,query}:{content:any,query:any}){
    const classes = useStyles();
    const [list, setList] = useState<ICuentasXCobrar[]>([]);
    useEffect(()=>{
        let l = filterCxCList(content,query);
        setList(l);
    },[content,query,setList])

    return (
        <>
            <div className={classes.tableCxc}>
                {list.map(pre=>
                    <div key={pre.prestamoId}>
                        <div className={"head"}>
                            <Typography color={"primary"}>{pre.cliente}</Typography>
                            <Typography variant="caption" className="estado">
                                {pre.estado === ESTADO_PRESTAMO.ACTIVO ? (
                                    <>{getValueString(SITUACION_PRESTAMO, pre.situacion)}</>
                                ):(
                                    <>{getValueString(ESTADO_PRESTAMO, pre.estado)}</>
                                )}

                                {(pre.estado === ESTADO_PRESTAMO.ACTIVO && pre.situacion === SITUACION_PRESTAMO.CUOTAS_VENCIDA) && ": "+pre.cuotasAtrasadas}
                            </Typography>
                        </div>
                        <div className={"detalles"}>
                            <div className={classes.infoPrestamo}>
                                <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                        <span>{Strings.telefono}:</span>
                                        <span>{pre.telefono}</span>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <span>{Strings.celular}:</span>
                                        <span>{pre.celular}</span>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <span>{Strings.direccion}:</span>
                                        <span>{pre.direccion}</span>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <span>{Strings.cuotas} {Strings.pagada}:</span>
                                        <span>{pre.plazoString}</span>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <span>{Strings.balance} {Strings.pendiente}:</span>
                                        <span>{formatPeso(pre.balancePendiente)}</span>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <span>{Strings.monto} {Strings.cuota}:</span>
                                        <span>{formatPeso(pre.montoCuota)}</span>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <span>{Strings.proximo} {Strings.pago}:</span>
                                        <span>{formatDate(pre.fechaProximoPago,"DD MMMM, YYYY")}</span>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {/*{list.map(e=>*/}
            {/*    <ItemPrestamo key={e.preId} item={e}/>*/}
            {/*)}*/}
        </>
    )
}
function DetallesPrestamo({content,aMostrar}:{content:IPrestamoDetalle,aMostrar:string[]}){
    // const classes = useStyles();
    const [doc, setDoc] = useState<string>()
    useEffect(()=>{
        exportPrestamoDetalle({id:content.id!, encabezado: aMostrar.includes("cabecera"), amortizacion: aMostrar.includes("amortizacion")}).then(res=>{

            var reader = new FileReader();
            reader.readAsDataURL(res.data);
            reader.onloadend = function() {
                var base64data = reader.result;

              setDoc(base64data as string);
            }


        })
    },[content, aMostrar]);

    useEffect(()=>{
        document.title = Strings.detalles+" "+Strings.prestamo+"_"+content.cliente;
    },[content]);


    // const pagos = content.pagos?.filter(p=>!p.fechaAnulacion);


    return(
        <>
            {doc &&
                <>
                    {isMobile.AndroidWebView() ?(
                        <Typography>Generado!</Typography>
                    ):(
                        <iframe src={doc} title={"documento"} style={{width:"100%", height:"calc(100vh - 59px)"}}></iframe>
                    )}
                </>
            }
        </>
    )
}
function Contrato({content}:{content:any}){
    const classes = useStyles();

    return (
        <div className={classes.contratoContent}>
            {parseHtml(content)}
        </div>
    )
}
function Cliente({content}:{content:ICliente}){
    const customFormInput = useCustomFormInput("cliente") as ConfCamposType;
    const classes = useStyles();
    useEffect(()=>{
        document.title = Strings.cliente+` ${content.nombres} ${content.apellidos}`;
    },[content])
    let {tipo} = content;
    return (
        <>
            <br/>
            <Grid container spacing={3}>
                {content.avatar &&
                    <Grid item xs={2}>
                        <div>
                            <img src={content.avatar} height="135" width="135" alt="Avatar"/>
                        </div>
                    </Grid>}
                <Grid item xs={content.avatar ? 10 :12} sx={{marginBottom: 8}}>
                    <Grid container spacing={3}>
                        {tipo === 2 &&
                            <Grid item xs={3}>
                                <div className={classes.campo}>
                                    <span>{content.razonSocial}</span>
                                    <label>{Strings.razonSocial}</label>
                                </div>
                            </Grid>}
                        <Grid item xs={6}>
                            <div className={classes.campo}>
                                <span>{content.nombres} {content.apellidos}</span>
                                <label>{Strings.primerNombre}</label>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span>{content.cedula}</span>
                                <label>{tipo === 2 ? geoString("rnc",true):Strings.cedula}</label>
                            </div>
                        </Grid>
                        {tipo !== 2 &&
                            <Grid item xs={3}>
                                <div className={classes.campo}>
                                    <span>{content.sexo}</span>
                                    <label>{Strings.genero}</label>
                                </div>
                            </Grid>
                        }
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span>{content.celular}</span>
                                <label>{Strings.celular}</label>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span>{content.telefono}</span>
                                <label>{Strings.telefono}</label>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span>{content.paisIdNacionalidad}</span>
                                <label>{Strings.nacionalidad}</label>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span><SelectEnum value={content.tipoVivienda} group={"tiposVivienda"} /></span>
                                <label>{Strings.vivienda}</label>
                            </div>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={3} className={classes.cliItems}>
                {tipo !== 2 && <>
                    <Grid item xs={2}>
                        <div className={classes.campo}>
                            <span><SelectEnum value={content.condicionLaboral} group={"condicionesLaboral"} /></span>
                            <label>{Strings.condicionesLaboral}</label>
                        </div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className={classes.campo}>
                            <span>{formatPeso(content.ingresos)}</span>
                            <label>{Strings.ingreso}</label>
                        </div>
                    </Grid>
                    <Grid item xs={2}>
                        <div className={classes.campo}>
                            <span>{translateText(content.estadoCivil)}</span>
                            <label>{Strings.estadoCivil}</label>
                        </div>
                    </Grid>
                    <Grid item xs={2}>
                        <div className={classes.campo}>
                            <span>{content.dependientes}</span>
                            <label>{Strings.dependientes}</label>
                        </div>
                    </Grid>
                </>}

                {customFormInput && Object.keys(customFormInput).map((key)=><>
                    <Grid item xs={3}>
                        <div className={classes.campo}>
                            <span>{(content as any)[key]}</span>
                            <label>{(customFormInput as any)[key].name}</label>
                        </div>
                    </Grid>
                </>)}
                <Grid item xs={12}>
                    <div className={classes.campo}>
                        <span>{content.direccion} {content?.direccion2?.indexOf("http") === -1 && " / "+content.direccion2}</span>
                        <label>{Strings.direccion}</label>
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.campo}>
                        <span>{content.codigoPostal}</span>
                        <label>{Strings.codigoPostal}</label>
                    </div>
                </Grid>
                {tipo !== 2 &&
                    <Grid item xs={3}>
                        <div className={classes.campo}>
                            <span>{formatDate(content.fechaNacimiento)}</span>
                            <label>{Strings.fechaNacimiento}</label>
                        </div>
                    </Grid>}
                <Grid item xs={2}>
                    <div className={classes.campo}>
                        <span>{content.faceBook}</span>
                        <label>FaceBook</label>
                    </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.campo}>
                        <span>{content.instagram}</span>
                        <label>Instagram</label>
                    </div>
                </Grid>
                <Grid item xs={3}>
                    <div className={classes.campo}>
                        <span>{content.email}</span>
                        <label>Email</label>
                    </div>
                </Grid>
            </Grid>
            {content.condicionLaboral === 1 && tipo !== 2 &&
                <>
                    <br/>
                    <Typography color={"secondary"}>{Strings.empresa}</Typography>
                    <br/>
                    <Grid container spacing={3} className={classes.cliItems}>
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span>{content.trabajoNombre}</span>
                                <label>{Strings.empresa}</label>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span><SelectEnum value={content.trabajoIntervaloCobro} group={"ciclosPago"} /></span>
                                <label>{Strings.intervaloCobro}</label>
                            </div>

                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span>{content.diasCobro}</span>
                                <label>{Strings.diasCobro}</label>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span>{content.trabajoPosicion}</span>
                                <label>{Strings.posicion}</label>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span>{content.tiempoLaborando}</span>
                                <label>{Strings.tiempoLaborando}</label>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.campo}>
                                <span>{content.trabajoTelefono}</span>
                                <label>{Strings.telefono}</label>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className={classes.campo}>
                                <span>{content.trabajoDireccion}</span>
                                <label>{Strings.direccion}</label>
                            </div>
                        </Grid>
                    </Grid>
                </>
            }
            {!!content?.referencias?.length &&
                <>
                    <br/>
                    <Typography color={"secondary"}>{Strings.referencia}</Typography>
                    <br/>
                    <TableContainer>
                        <Table className={"noHover"} size={"small"}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{Strings.tipo}</TableCell>
                                    <TableCell>{Strings.nombreCompleto}</TableCell>
                                    <TableCell>{Strings.telefono}</TableCell>
                                    <TableCell>{Strings.parentesco}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {content.referencias.map((ref,i)=>{
                                    return(
                                        <TableRow key={i+1}>
                                            <TableCell>{translateText(ref.tipoString)}</TableCell>
                                            <TableCell>{ref.nombre}</TableCell>
                                            <TableCell>{ref.telefono}</TableCell>
                                            <TableCell>{translateText(ref.parentesco)}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }
        </>
    )
}
function Amortizacion({content,query,aMostrar = []}:{content:IAmortizacion[],query:any,aMostrar:string[]}){
    const classes = useStyles();
    const [simularComision,setSimularComision] = useState(false);
    const [comision, setComision] = useState(0);


    return(
        <>
            <div className={classes.infoPrestamo}>
                <Grid container spacing={1} >
                    <Grid item xs={4}  >
                        <span>{Strings.primerPago}:</span>
                        <span>{formatDate(query.fecha)}</span>
                    </Grid>
                    <Grid item xs={4}  >
                        <span>{Strings.capitalInicial}:</span>
                        <span>{formatPeso(query.capital)}</span>
                    </Grid>
                    <Grid item xs={4}  >
                        <span>{Strings.cuotas}:</span>
                        <span>{query.cuotas}</span>
                    </Grid>
                    <Grid item xs={4}  >
                        <span>{Strings.amortizacion}:</span>
                        <span><SelectEnum value={+query.tipoAmortizacian} group={"tiposAmortizacion"} /></span>
                    </Grid>
                    <Grid item xs={4} >
                        <span>{Strings.interes}:</span>
                        <span>{query.interes} %</span>
                    </Grid>
                    <Grid item xs={4} >
                        <span>{Strings.modalidad}:</span>
                        <span><SelectEnum value={+query.ciclosPago} group={"ciclosPago"} /></span>
                    </Grid>
                </Grid>
            </div>
            <Box p={1} className={"noPrint"}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <HtmlTooltip title={Strings.simularComisionMsj}>
                            <FormControlLabel
                                control={<Checkbox checked={simularComision}
                                                   onChange={e=>setSimularComision(e.target.checked)} />}
                                label={"Simular "+Strings.comision} />
                        </HtmlTooltip>
                    </Grid>
                    <Grid item xs={6}>
                        {simularComision &&
                            <TextField
                                name="comision"
                                required={simularComision}
                                value={comision}
                                onChange={({target})=>target.value ? setComision(parseFloat(target.value)): undefined}
                                type="number"
                                inputProps={{step:"any",inputMode:"decimal"}}
                                fullWidth
                                label={Strings.comision}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                }}
                                margin={"none"}
                                size="small"
                                variant={"outlined"}
                            />
                        }
                    </Grid>
                </Grid>
            </Box>

            <div className={classes.barTitle}>
                <Typography color={"secondary"}>{Strings.amortizacion}</Typography>
                {aMostrar.includes("total") &&
                    <div className="total">
                        <div>
                            <span >{Strings.total} {Strings.interes}: {!!simularComision && <>+ {Strings.comision}</>}</span> <i> {formatPeso(content?.reduce((a, b) => +a + (b.interes ?? 0), 0))}</i>
                        </div>
                        <div>
                            <span>{Strings.totalApagar}: </span> <i> {formatPeso(content?.reduce((a, b) => +a + (b.total ?? 0), 0))}</i>
                        </div>
                    </div>
                }
            </div >
            <TableContainer>
                <Table className={"noHover"} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>No - {Strings.fecha}</TableCell>
                            <TableCell className="hl">{Strings.totalApagar}</TableCell>
                            <TableCell>{Strings.capitalPendiente}</TableCell>
                            <TableCell>{Strings.abonoCapital}</TableCell>
                            <TableCell>{Strings.interes}</TableCell>
                            {!!simularComision &&
                                <TableCell>{Strings.comision}</TableCell>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {content?.map(n => {
                            return (
                                <TableRow key={n.cuota}>
                                    <TableCell>{n.cuota} - {n.fecha}</TableCell>
                                    <TableCell className="hl">{formatPeso(n.total)}</TableCell>
                                    <TableCell>{formatPeso(n.capitalPendiente)}</TableCell>
                                    <TableCell>{formatPeso(n.capital)}</TableCell>
                                    {!!simularComision?(
                                        <>
                                            <TableCell>{formatPeso((n.interes ?? 0) * ((100 - comision) / 100))}</TableCell>
                                            <TableCell>{formatPeso((n.interes ?? 0) * (comision/100))}</TableCell>
                                        </>
                                    ):(
                                        <TableCell>{formatPeso(n.interes)}</TableCell>
                                    )}

                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

